import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import User from 'main/stores/users/User';
import {t} from 'shared/core';

class Recipient extends DomainObject {
  id;
  recipientType;
  user;

  _relations = {
    recipientType: oneOf(['employee', 'manager', 'specific_user']),
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      recipientType: observable,
      user: observable,
      value: computed,
      name: computed
    });

    this.merge(other);
  }

  get value() {
    switch (this.recipientType) {
      case 'specific_user':
        return this.user.id;
      case 'employee':
      case 'manager':
        return this.recipientType;
      default:
        throw new Error(`Recipient type ${this.reminderType} not supported.`);
    }
  }

  get name() {
    switch (this.recipientType) {
      case 'specific_user':
        return this.user.name;
      case 'employee':
      case 'manager':
        return t(`models.reminders.recipients.${this.recipientType}`);
      default:
        throw new Error(`Recipient type ${this.reminderType} not supported.`);
    }
  }
}

export default Recipient;
